import { BasePlanData } from "./BasePlanData";

export class NewPlanDto extends BasePlanData {

    planStartMonth: number = 0;
    planStartYear: string = '';
    actualsStartMonth: number = 0;
    actualsStartYear: string = '';
    planName: string = '';
    duration: number = 0;
    yearEndMonth: number = 0;
    currencyId: number = 0;
    aVatCalcOption: number = 0;
    // plan template
    aTemplateName: string = '';    
    taxSystem: string = '';
    companyId: number = 0;

    constructor() { 
        super();
        this.actualsPlanStartDate = this._actualsPlanStartDate;
        this.planStartDate = this._planStartDate;   
    }
}